<svg
	*ngIf="!isCorporate"
	class="keep-flying-illustration"
	version="1.1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	x="0px"
	y="0px"
	viewBox="0 0 76 76"
	enable-background="new 0 0 76 76"
	xml:space="preserve"
>
	<g id="get-miles-plane">
		<g id="plane-and-path">
			<circle id="Oval" fill="none" cx="38" cy="38" r="38" />
			<path
				id="path"
				fill="#94C83D"
				d="M43.2,9.6c0.5,0.1,0.9,0.6,0.8,1.1c0,0,0,0,0,0.1c-0.1,0.5-0.6,0.9-1.1,0.8c0,0-0.1,0-0.1,0
		 c-1.6-0.3-3.3-0.5-5-0.5c-0.6,0-1-0.5-1-1s0.5-1,1-1C39.7,9.1,41.5,9.3,43.2,9.6z M55.8,15.3c0.4,0.3,0.5,1,0.2,1.4c0,0,0,0,0,0.1
		 c-0.3,0.4-1,0.5-1.4,0.2c0,0,0,0-0.1,0c-1.3-1-2.7-1.9-4.2-2.7c-0.5-0.3-0.7-0.9-0.4-1.4c0,0,0,0,0,0c0.2-0.5,0.8-0.7,1.3-0.5
		 c0,0,0,0,0.1,0C53,13.2,54.5,14.2,55.8,15.3z M64.3,26.2c0.2,0.5,0,1.1-0.5,1.4c-0.5,0.2-1.1,0-1.4-0.5l0,0
		 c-0.7-1.5-1.5-3-2.4-4.3c-0.3-0.4-0.2-1.1,0.2-1.4c0,0,0,0,0.1,0c0.4-0.3,1.1-0.2,1.4,0.2c0,0,0,0,0,0.1
		 C62.7,23,63.6,24.6,64.3,26.2z M66.8,39.8c0,0.6-0.4,1-1,1c0,0-0.1,0-0.1,0c-0.6,0-1-0.4-1-1c0,0,0-0.1,0-0.1c0-0.5,0-1.1,0-1.7
		 c0-1.1-0.1-2.2-0.2-3.3c-0.1-0.6,0.3-1.1,0.9-1.1c0.6-0.1,1.1,0.3,1.1,0.9l0,0c0.2,1.2,0.3,2.4,0.3,3.5
		 C66.8,38.6,66.8,39.2,66.8,39.8z M62.7,53c-0.3,0.5-0.9,0.6-1.4,0.3c-0.5-0.3-0.6-0.9-0.4-1.4c0.9-1.4,1.6-2.9,2.2-4.5
		 c0.2-0.5,0.8-0.8,1.3-0.6c0.5,0.2,0.8,0.8,0.6,1.3C64.4,49.8,63.6,51.5,62.7,53z M52.9,62.8c-0.5,0.3-1.1,0.1-1.4-0.4
		 s-0.1-1.1,0.4-1.4l0,0c1.4-0.9,2.8-1.9,4-3c0.4-0.4,1.1-0.3,1.5,0.1c0.4,0.4,0.3,1.1-0.1,1.5C55.9,60.7,54.5,61.8,52.9,62.8
		 L52.9,62.8z M39.8,66.9c-0.5,0.1-1-0.3-1.1-0.9c0,0,0-0.1,0-0.1c-0.1-0.5,0.3-1,0.9-1.1c0,0,0.1,0,0.1,0c1.7-0.1,3.3-0.4,4.9-0.8
		 c0.6-0.1,1.1,0.2,1.3,0.7c0.1,0.6-0.2,1.1-0.7,1.3C43.3,66.5,41.6,66.8,39.8,66.9z M26.1,64.5c-0.5-0.2-0.8-0.8-0.6-1.3
		 c0,0,0,0,0-0.1c0.2-0.5,0.8-0.8,1.3-0.6c0,0,0.1,0,0.1,0c1.5,0.7,3.1,1.2,4.7,1.6c0.6,0.1,0.9,0.7,0.8,1.2
		 c-0.1,0.6-0.7,0.9-1.2,0.8C29.5,65.8,27.8,65.2,26.1,64.5z M15.2,56c-0.4-0.4-0.3-1.1,0.2-1.5s1.1-0.3,1.5,0.2
		 c1,1.3,2.2,2.5,3.4,3.6c0.4,0.4,0.5,1,0.1,1.5c-0.4,0.4-1,0.5-1.5,0.1l0,0C17.6,58.7,16.3,57.4,15.2,56z M9.5,43.4
		 c-0.1-0.6,0.3-1.1,0.8-1.2s1.1,0.3,1.2,0.8c0.3,1.6,0.8,3.2,1.4,4.8c0.2,0.5,0,1.1-0.5,1.3c0,0,0,0-0.1,0
		 c-0.5,0.2-1.1-0.1-1.3-0.6C10.3,46.9,9.8,45.2,9.5,43.4z M10.2,29.6c0.1-0.5,0.7-0.8,1.2-0.7c0,0,0,0,0.1,0
		 c0.5,0.1,0.9,0.7,0.7,1.2c0,0,0,0,0,0.1c-0.5,1.6-0.8,3.2-1,4.9c-0.1,0.6-0.6,1-1.1,0.9c-0.6-0.1-1-0.6-0.9-1.1
		 C9.3,33.1,9.7,31.3,10.2,29.6z"
			/>
			<g id="plane">
				<path
					id="Fill-21"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#56BA22"
					d="M19.8,20.1L19.8,20.1l0.5-0.3L19.8,20.1z"
				/>
				<path
					id="Fill-23"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#56BA22"
					d="M19.8,20.2L19.8,20.2C19.2,20.5,18.5,21,19.8,20.2
			 "
				/>
				<path
					id="Fill-25"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#94CE28"
					d="M11.4,21.9l1.6-1.6L26.3,12
			 c0.8-0.5,1.7-0.9,2.7-1.2L28.8,11c-0.2,0.1-0.3,0.4-0.1,0.6l0.2,0.4l0,0c0,0,0.1,0.1,0.1,0.1H29c0.1,0,0.2,0,0.2,0l1.5-0.9
			 c2,0.5-0.4,2.4-2.6,3.8l-8.3,5.2c-2.4,1.4-5.1,2.3-7.9,2.6L11.4,21.9z"
				/>
				<path
					id="Fill-27"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#1B9B05"
					d="M29.2,12.1c-0.1,0-0.2,0-0.2,0
			 C29.1,12.1,29.2,12.1,29.2,12.1l1.5-0.9L29.2,12.1z"
				/>
				<path
					id="Fill-29"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#127045"
					d="M28.7,11l0.2-0.1c0.3-0.1,0.7,0,1,0.1l0.4,0.1
			 l0.4,0.1l-1.5,0.9c-0.1,0-0.2,0-0.2,0h-0.1c-0.1,0-0.1-0.1-0.1-0.1l0,0l-0.2-0.4C28.4,11.4,28.5,11.1,28.7,11"
				/>
				<path
					id="Fill-31"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#1B9B05"
					d="M28.8,12L28.8,12c0,0,0.1,0.1,0.1,0.1
			 C28.9,12.1,28.9,12,28.8,12"
				/>
				<polygon
					id="Fill-37"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#F1FF8D"
					points="12.9,17.1 14.4,19.4 14.1,18.6 15.4,17.8
			 15.9,18.3 16,18.4 14.4,19.5 			"
				/>
				<polygon
					id="Fill-41"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#94CE28"
					points="15.9,18.3 15.4,17.8 14.1,18.6 14.4,19.4
			 12.9,17.1 15.7,17.9 			"
				/>
				<path
					id="Fill-43"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#EF5854"
					d="M11.9,17.9l-0.4-0.6l-0.8,0.5l-0.9-1l0.1-0.1
			 l0.3-0.2c0.2-0.1,0.5-0.1,0.7,0l1.4,0.4l0.9,3.2L12.6,19l-0.5,0.3l-0.9-1L11.9,17.9L11.9,17.9z"
				/>
				<polygon
					id="Fill-45"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#76B743"
					points="16.1,18.4 16,18.4 15.9,18.3 			"
				/>
				<path
					id="Fill-47"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#56BA22"
					d="M15.7,17.9L15.7,17.9c0,0,0.8,0.2,1.1,0L16,18.4
			 l-0.1-0.1L15.7,17.9z"
				/>
				<polygon
					id="Fill-51"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#D13D3D"
					points="12.3,16.9 12.9,17.1 14.4,19.5 13.3,20.1
			 13.3,20.1 			"
				/>
				<path
					id="Fill-53"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#1B9B05"
					d="M20.7,18.9c0.3,0.4,0.8,0.6,1.3,0.4
			 c0.7-0.1,1.5-0.4,2.1-0.8c0.4-0.3,0.5-0.8,0.3-1.2c0,0,0,0,0,0l-0.7-1.1c-0.3-0.4-0.5,0-0.9,0.2l-1.9,1.2
			 c-0.4,0.3-0.8,0.3-0.6,0.7L20.7,18.9z"
				/>
				<path
					id="Fill-55"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#56BA22"
					d="M17.1,20c0.2,0.4,0.7,0.5,1.1,0.3l7-4.4
			 c0.4-0.2,0.5-0.7,0.3-1.1c-0.2-0.4-0.7-0.5-1.1-0.3c0,0-0.1,0-0.1,0.1l-7,4.4C17,19.2,16.9,19.7,17.1,20"
				/>
			</g>
		</g>
		<g id="miles">
			<g id="miles-box">
				<path
					id="Rectangle-Copy-2"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#F3F1E9"
					d="M29.3,33.4h17.3c3.4,0,6.1,2.7,6.1,6.1
			 c0,0,0,0,0,0l0,0c0,3.4-2.7,6.1-6.1,6.1c0,0,0,0,0,0H29.3c-3.4,0-6.1-2.7-6.1-6.1l0,0l0,0C23.3,36.1,26,33.4,29.3,33.4
			 C29.3,33.4,29.3,33.4,29.3,33.4z"
				/>
				<path
					id="Rectangle-Copy-3"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#D4B4A1"
					d="M29.4,37h17.3c1,0,1.8,0.8,1.8,1.8l0,0
			 c0,1-0.8,1.8-1.8,1.8H29.4c-1,0-1.8-0.8-1.8-1.8l0,0C27.6,37.8,28.4,37,29.4,37z"
				/>
			</g>
			<g id="miles-coin">
				<path
					id="Path-2"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#297C4C"
					d="M38,21.3c-5.1,0-9.2,4.1-9.2,9.2s4.1,9.2,9.2,9.2
			 c5.1,0,9.2-4.1,9.2-9.2c0,0,0,0,0,0C47.2,25.5,43.1,21.3,38,21.3"
				/>
				<path
					id="Combined-Shape-2"
					fill="#1D9B48"
					d="M37.8,22.2c-4.6,0.1-8.2,3.8-8.1,8.4s3.8,8.2,8.4,8.1s8.2-3.8,8.1-8.4
			 c-0.1-4.4-3.7-8-8.1-8.1H37.8z M38.2,20.4c5.6,0.1,10.1,4.7,10,10.3c-0.1,5.6-4.7,10.1-10.3,10s-10.1-4.7-10-10.3
			 c0.1-5.5,4.5-9.9,10-10H38.2z"
				/>
				<path
					id="Fill-3"
					fill-rule="evenodd"
					clip-rule="evenodd"
					fill="#FEFEFE"
					d="M41.3,26.6c-0.3-0.1-0.6,0-0.7,0.2l-2.5,3l-2.5-3
			 c-0.2-0.2-0.5-0.3-0.7-0.2c-0.3,0.1-0.4,0.3-0.4,0.6v6.4c0,0.4,0.4,0.6,0.8,0.6c0.3,0,0.5-0.3,0.6-0.6V29l1.8,2.2
			 c0.1,0.2,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2l1.8-2.2v4.6c0,0.4,0.4,0.6,0.8,0.6c0.3,0,0.5-0.3,0.6-0.6v-6.4
			 C41.7,26.9,41.5,26.7,41.3,26.6"
				/>
			</g>
		</g>
	</g>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		fill="#F3F1E9"
		d="M52.7,38.8h-4.3c0,0,0,0.1,0,0.1c0,1-0.8,1.8-1.8,1.8H29.4
 c-1,0-1.8-0.8-1.8-1.8c0,0,0-0.1,0-0.1h-4.3c0,0.2,0,0.5,0,0.7c0,3.4,2.7,6.1,6.1,6.1h17.3c3.4,0,6.1-2.7,6.1-6.1c0,0,0,0,0,0
 C52.7,39.2,52.7,39,52.7,38.8z"
	/>
	<path
		id="Combined-Shape"
		fill-rule="evenodd"
		clip-rule="evenodd"
		fill="#D4B4A1"
		d="M23.3,40c0.3,3.1,2.9,5.5,6,5.5h17.3
 c3.2,0,5.8-2.4,6.1-5.5c0,0.2,0,0.4,0,0.6v3.8c0,4-3.2,7.3-7.3,7.3h-15c-4,0-7.3-3.2-7.3-7.3v-3.8c0-0.1,0-0.3,0-0.4L23.3,40z"
	/>
</svg>

<svg
	*ngIf="isCorporate"
	class="keep-flying-illustration"
	version="1.1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	x="0px"
	y="0px"
	viewBox="0 0 76 76"
	enable-background="new 0 0 76 76"
	xml:space="preserve"
>
	<g id="Sprite" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
		<g id="Group-Copy" transform="translate(0.500000, 0.000000)">
			<g id="get-miles-plane0">
				<g id="plane-and-path0">
					<circle id="Oval" cx="38" cy="38" r="38"></circle>
					<path
						d="M43.2,9.6 C43.7,9.7 44.1,10.2 44,10.7 C44,10.7 44,10.7 44,10.8 C43.9,11.3 43.4,11.7 42.9,11.6 C42.9,11.6 42.8,11.6 42.8,11.6 C41.2,11.3 39.5,11.1 37.8,11.1 C37.2,11.1 36.8,10.6 36.8,10.1 C36.8,9.6 37.3,9.1 37.8,9.1 C39.7,9.1 41.5,9.3 43.2,9.6 Z M55.8,15.3 C56.2,15.6 56.3,16.3 56,16.7 C56,16.7 56,16.7 56,16.8 C55.7,17.2 55,17.3 54.6,17 C54.6,17 54.6,17 54.5,17 C53.2,16 51.8,15.1 50.3,14.3 C49.8,14 49.6,13.4 49.9,12.9 C49.9,12.9 49.9,12.9 49.9,12.9 C50.1,12.4 50.7,12.2 51.2,12.4 C51.2,12.4 51.2,12.4 51.3,12.4 C53,13.2 54.5,14.2 55.8,15.3 Z M64.3,26.2 C64.5,26.7 64.3,27.3 63.8,27.6 C63.3,27.8 62.7,27.6 62.4,27.1 L62.4,27.1 C61.7,25.6 60.9,24.1 60,22.8 C59.7,22.4 59.8,21.7 60.2,21.4 C60.2,21.4 60.2,21.4 60.3,21.4 C60.7,21.1 61.4,21.2 61.7,21.6 C61.7,21.6 61.7,21.6 61.7,21.7 C62.7,23 63.6,24.6 64.3,26.2 Z M66.8,39.8 C66.8,40.4 66.4,40.8 65.8,40.8 C65.8,40.8 65.7,40.8 65.7,40.8 C65.1,40.8 64.7,40.4 64.7,39.8 C64.7,39.8 64.7,39.7 64.7,39.7 C64.7,39.2 64.7,38.6 64.7,38 C64.7,36.9 64.6,35.8 64.5,34.7 C64.4,34.1 64.8,33.6 65.4,33.6 C66,33.5 66.5,33.9 66.5,34.5 L66.5,34.5 C66.7,35.7 66.8,36.9 66.8,38 C66.8,38.6 66.8,39.2 66.8,39.8 Z M62.7,53 C62.4,53.5 61.8,53.6 61.3,53.3 C60.8,53 60.7,52.4 60.9,51.9 C61.8,50.5 62.5,49 63.1,47.4 C63.3,46.9 63.9,46.6 64.4,46.8 C64.9,47 65.2,47.6 65,48.1 C64.4,49.8 63.6,51.5 62.7,53 Z M52.9,62.8 C52.4,63.1 51.8,62.9 51.5,62.4 C51.2,61.9 51.4,61.3 51.9,61 L51.9,61 C53.3,60.1 54.7,59.1 55.9,58 C56.3,57.6 57,57.7 57.4,58.1 C57.8,58.5 57.7,59.2 57.3,59.6 C55.9,60.7 54.5,61.8 52.9,62.8 L52.9,62.8 Z M39.8,66.9 C39.3,67 38.8,66.6 38.7,66 C38.7,66 38.7,65.9 38.7,65.9 C38.6,65.4 39,64.9 39.6,64.8 C39.6,64.8 39.7,64.8 39.7,64.8 C41.4,64.7 43,64.4 44.6,64 C45.2,63.9 45.7,64.2 45.9,64.7 C46,65.3 45.7,65.8 45.2,66 C43.3,66.5 41.6,66.8 39.8,66.9 Z M26.1,64.5 C25.6,64.3 25.3,63.7 25.5,63.2 C25.5,63.2 25.5,63.2 25.5,63.1 C25.7,62.6 26.3,62.3 26.8,62.5 C26.8,62.5 26.9,62.5 26.9,62.5 C28.4,63.2 30,63.7 31.6,64.1 C32.2,64.2 32.5,64.8 32.4,65.3 C32.3,65.9 31.7,66.2 31.2,66.1 C29.5,65.8 27.8,65.2 26.1,64.5 Z M15.2,56 C14.8,55.6 14.9,54.9 15.4,54.5 C15.9,54.1 16.5,54.2 16.9,54.7 C17.9,56 19.1,57.2 20.3,58.3 C20.7,58.7 20.8,59.3 20.4,59.8 C20,60.2 19.4,60.3 18.9,59.9 L18.9,59.9 C17.6,58.7 16.3,57.4 15.2,56 Z M9.5,43.4 C9.4,42.8 9.8,42.3 10.3,42.2 C10.8,42.1 11.4,42.5 11.5,43 C11.8,44.6 12.3,46.2 12.9,47.8 C13.1,48.3 12.9,48.9 12.4,49.1 C12.4,49.1 12.4,49.1 12.3,49.1 C11.8,49.3 11.2,49 11,48.5 C10.3,46.9 9.8,45.2 9.5,43.4 Z M10.2,29.6 C10.3,29.1 10.9,28.8 11.4,28.9 C11.4,28.9 11.4,28.9 11.5,28.9 C12,29 12.4,29.6 12.2,30.1 C12.2,30.1 12.2,30.1 12.2,30.2 C11.7,31.8 11.4,33.4 11.2,35.1 C11.1,35.7 10.6,36.1 10.1,36 C9.5,35.9 9.1,35.4 9.2,34.9 C9.3,33.1 9.7,31.3 10.2,29.6 Z"
						id="path"
						fill="#54B7F5"
						fill-rule="nonzero"
					></path>
					<g id="plane0" transform="translate(9.000000, 10.000000)">
						<polygon
							id="Fill-210"
							fill="#43A0DF"
							points="10.8 10.1 10.8 10.1 11.3 9.8"
						></polygon>
						<path
							d="M10.8,10.2 L10.8,10.2 C10.2,10.5 9.5,11 10.8,10.2"
							id="Fill-230"
							fill="#43A0DF"
						></path>
						<path
							d="M2.4,11.9 L4,10.3 L17.3,2 C18.1,1.5 19,1.1 20,0.8 L19.8,1 C19.6,1.1 19.5,1.4 19.7,1.6 L19.9,2 L19.9,2 C19.9,2 20,2.1 20,2.1 L20,2.1 C20.1,2.1 20.2,2.1 20.2,2.1 L21.7,1.2 C23.7,1.7 21.3,3.6 19.1,5 L10.8,10.2 C8.4,11.6 5.7,12.5 2.9,12.8 L2.4,11.9 Z"
							id="Fill-250"
							fill="#54B7F5"
						></path>
						<path
							d="M20.2,2.1 C20.1,2.1 20,2.1 20,2.1 C20.1,2.1 20.2,2.1 20.2,2.1 L21.7,1.2 L20.2,2.1 Z"
							id="Fill-270"
							fill="#1C75BB"
						></path>
						<path
							d="M19.7,1 L19.9,0.9 C20.2,0.8 20.6,0.9 20.9,1 L21.3,1.1 L21.7,1.2 L20.2,2.1 C20.1,2.1 20,2.1 20,2.1 L19.9,2.1 C19.8,2.1 19.8,2 19.8,2 L19.8,2 L19.6,1.6 C19.4,1.4 19.5,1.1 19.7,1"
							id="Fill-290"
							fill="#084E87"
						></path>
						<path
							d="M19.8,2 L19.8,2 C19.8,2 19.9,2.1 19.9,2.1 C19.9,2.1 19.9,2 19.8,2"
							id="Fill-310"
							fill="#1C75BB"
						></path>
						<polygon
							id="Fill-370"
							fill="#CFECFE"
							points="3.9 7.1 5.4 9.4 5.1 8.6 6.4 7.8 6.9 8.3 7 8.4 5.4 9.5"
						></polygon>
						<polygon
							id="Fill-410"
							fill="#54B7F5"
							points="6.9 8.3 6.4 7.8 5.1 8.6 5.4 9.4 3.9 7.1 6.7 7.9"
						></polygon>
						<path
							d="M2.9,7.9 L2.5,7.3 L1.7,7.8 L0.8,6.8 L0.9,6.7 L1.2,6.5 C1.4,6.4 1.7,6.4 1.9,6.5 L3.3,6.9 L4.2,10.1 L3.6,9 L3.1,9.3 L2.2,8.3 L2.9,7.9 L2.9,7.9 Z"
							id="Fill-430"
							fill="#EF5854"
						></path>
						<polygon
							id="Fill-450"
							fill="#1C75BB"
							points="7.1 8.4 7 8.4 6.9 8.3"
						></polygon>
						<path
							d="M6.7,7.9 L6.7,7.9 C6.7,7.9 7.5,8.1 7.8,7.9 L7,8.4 L6.9,8.3 L6.7,7.9 Z"
							id="Fill-470"
							fill="#1C75BB"
						></path>
						<polygon
							id="Fill-510"
							fill="#D13D3D"
							points="3.3 6.9 3.9 7.1 5.4 9.5 4.3 10.1 4.3 10.1"
						></polygon>
						<path
							d="M11.7,8.9 C12,9.3 12.5,9.5 13,9.3 C13.7,9.2 14.5,8.9 15.1,8.5 C15.5,8.2 15.6,7.7 15.4,7.3 C15.4,7.3 15.4,7.3 15.4,7.3 L14.7,6.2 C14.4,5.8 14.2,6.2 13.8,6.4 L11.9,7.6 C11.5,7.9 11.1,7.9 11.3,8.3 L11.7,8.9 Z"
							id="Fill-530"
							fill="#1C75BB"
						></path>
						<path
							d="M8.1,10 C8.3,10.4 8.8,10.5 9.2,10.3 L16.2,5.9 C16.6,5.7 16.7,5.2 16.5,4.8 C16.3,4.4 15.8,4.3 15.4,4.5 C15.4,4.5 15.3,4.5 15.3,4.6 L8.3,9 C8,9.2 7.9,9.7 8.1,10"
							id="Fill-550"
							fill="#43A0DF"
						></path>
					</g>
				</g>
				<g id="miles0" transform="translate(23.000000, 20.000000)">
					<g id="miles-box0" transform="translate(0.000000, 13.000000)">
						<path
							d="M6.3,0.4 L23.6,0.4 C27,0.4 29.7,3.1 29.7,6.5 C29.7,6.5 29.7,6.5 29.7,6.5 L29.7,6.5 C29.7,9.9 27,12.6 23.6,12.6 C23.6,12.6 23.6,12.6 23.6,12.6 L6.3,12.6 C2.9,12.6 0.2,9.9 0.2,6.5 L0.2,6.5 L0.2,6.5 C0.3,3.1 3,0.4 6.3,0.4 C6.3,0.4 6.3,0.4 6.3,0.4 Z"
							id="Rectangle-Copy-20"
							fill="#F3F1E9"
						></path>
						<path
							d="M6.4,4 L23.7,4 C24.7,4 25.5,4.8 25.5,5.8 L25.5,5.8 C25.5,6.8 24.7,7.6 23.7,7.6 L6.4,7.6 C5.4,7.6 4.6,6.8 4.6,5.8 L4.6,5.8 C4.6,4.8 5.4,4 6.4,4 Z"
							id="Rectangle-Copy-30"
							fill="#D4B4A1"
						></path>
					</g>
					<g id="miles-coin0" transform="translate(4.000000, 0.000000)">
						<path
							d="M11,1.3 C5.9,1.3 1.8,5.4 1.8,10.5 C1.8,15.6 5.9,19.7 11,19.7 C16.1,19.7 20.2,15.6 20.2,10.5 C20.2,10.5 20.2,10.5 20.2,10.5 C20.2,5.5 16.1,1.3 11,1.3"
							id="Path-20"
							fill="#084E87"
						></path>
						<path
							d="M10.8,2.2 C6.2,2.3 2.6,6 2.7,10.6 C2.8,15.2 6.5,18.8 11.1,18.7 C15.7,18.6 19.3,14.9 19.2,10.3 C19.1,5.9 15.5,2.3 11.1,2.2 L10.8,2.2 Z M11.2,0.4 C16.8,0.5 21.3,5.1 21.2,10.7 C21.1,16.3 16.5,20.8 10.9,20.7 C5.3,20.6 0.8,16 0.9,10.4 C1,4.9 5.4,0.5 10.9,0.4 L11.2,0.4 Z"
							id="Combined-Shape-20"
							fill="#1C75BB"
							fill-rule="nonzero"
						></path>
						<path
							d="M11.0973482,14.844 C12.4413482,14.844 13.3293482,14.448 14.0853482,13.788 C14.2533482,13.644 14.3973482,13.416 14.3973482,13.128 C14.3973482,12.66 14.0013482,12.276 13.5333482,12.276 C13.3173482,12.276 13.1253482,12.36 12.9813482,12.48 C12.4533482,12.9 11.9373482,13.14 11.1573482,13.14 C9.71734819,13.14 8.72134819,11.94 8.72134819,10.5 L8.72134819,10.476 C8.72134819,9.036 9.74134819,7.86 11.1573482,7.86 C11.8173482,7.86 12.3573482,8.076 12.8733482,8.46 C13.0053482,8.544 13.1733482,8.64 13.4253482,8.64 C13.9293482,8.64 14.3373482,8.244 14.3373482,7.74 C14.3373482,7.416 14.1693482,7.152 13.9773482,7.008 C13.2813482,6.492 12.4293482,6.156 11.1693482,6.156 C8.58934819,6.156 6.78934819,8.112 6.78934819,10.5 L6.78934819,10.524 C6.78934819,12.936 8.62534819,14.844 11.0973482,14.844 Z"
							id="Corporate"
							fill="#FFFFFF"
							fill-rule="nonzero"
						></path>
					</g>
				</g>
			</g>
			<path
				d="M52.7,38.8 L48.4,38.8 C48.4,38.8 48.4,38.9 48.4,38.9 C48.4,39.9 47.6,40.7 46.6,40.7 L29.4,40.7 C28.4,40.7 27.6,39.9 27.6,38.9 C27.6,38.9 27.6,38.8 27.6,38.8 L23.3,38.8 C23.3,39 23.3,39.3 23.3,39.5 C23.3,42.9 26,45.6 29.4,45.6 L46.7,45.6 C50.1,45.6 52.8,42.9 52.8,39.5 C52.8,39.5 52.8,39.5 52.8,39.5 C52.7,39.2 52.7,39 52.7,38.8 Z"
				id="Path"
				fill="#F3F1E9"
			></path>
			<path
				d="M23.3,40 C23.6,43.1 26.2,45.5 29.3,45.5 L46.6,45.5 C49.8,45.5 52.4,43.1 52.7,40 C52.7,40.2 52.7,40.4 52.7,40.6 L52.7,44.4 C52.7,48.4 49.5,51.7 45.4,51.7 L30.4,51.7 C26.4,51.7 23.1,48.5 23.1,44.4 L23.1,40.6 C23.1,40.5 23.1,40.3 23.1,40.2 L23.3,40 Z"
				id="Combined-Shape0"
				fill="#D4B4A1"
			></path>
		</g>
	</g>
</svg>
